module.exports = __webpack_public_path__ + "img/kkgfxhsh.bb7079f2.png";